module.exports = __webpack_public_path__ + "assets/img/TextToSpeech-banner.907bc7c8.png";